import { Stack } from '@mui/material';
import React, { useState } from 'react';
import VastaanottoVarausAccordion from '@/components/VastaanottoVaraukset/VastaanottoVarausAccordion';
import DetailsSheet from '@/components/VarausDetails/DetailsSheet';

const VastaanottoVaraukset = () => {
  const [selectedVaraus, setSelectedVaraus] = useState(null);

  return (
    <Stack>
      <VastaanottoVarausAccordion type="alkavat" setSelectedVaraus={setSelectedVaraus} />
      <VastaanottoVarausAccordion type="loppuvat" setSelectedVaraus={setSelectedVaraus} />
      <VastaanottoVarausAccordion type="jatkuvat" setSelectedVaraus={setSelectedVaraus} />

      <DetailsSheet
        open={Boolean(selectedVaraus)}
        data={selectedVaraus}
        onClose={() => setSelectedVaraus(null)}
      />
    </Stack>
  );
};

export default VastaanottoVaraukset;
